"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccordion = exports.Accordion = void 0;
const ui_library_1 = require("@hum/ui-library");
const react_1 = __importStar(require("react"));
// import * as tabNavigationStyles from './TabNavigation.pc';
require("./Accordion.pc.css");
__exportStar(require("./AccordionFooter"), exports);
__exportStar(require("./AccordionContent"), exports);
exports.Accordion = (0, react_1.memo)(({ label, testId, open = false, children }) => {
    const { isOpen, toggleOpen } = (0, exports.useAccordion)(open);
    return (react_1.default.createElement("div", { "data-testid": testId },
        react_1.default.createElement(ui_library_1.Card, { onClick: () => {
                toggleOpen();
            }, className: "cursor-pointer flex items-center justify-between", testId: "accordion-header" },
            label,
            react_1.default.createElement(ui_library_1.Icon.ChevronRight, null)),
        isOpen && react_1.default.createElement("div", null, children)));
});
// export const AccordionTabNavigationItem = memo(
//   ({
//     label,
//     testId,
//     children,
//     onClick,
//     active = false,
//     open = false,
//   }: AccordionProps) => {
//     const { isOpen, toggleOpen } = useAccordion(open);
//     if (!active && isOpen) {
//       toggleOpen();
//     }
//     return (
//       <tabNavigationStyles.AccordionTabNavigationItem
//         active={active}
//         label={label}
//         key={testId}
//         testId={testId}
//         onExpandClick={toggleOpen}
//         onClick={() => {
//           onClick();
//           toggleOpen();
//         }}
//         expanded={isOpen}
//       >
//         {isOpen ? children : null}
//       </tabNavigationStyles.AccordionTabNavigationItem>
//     );
//   }
// );
const useAccordion = (open, disabled) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(open);
    const toggleOpen = (0, react_1.useCallback)(() => {
        if (!disabled) {
            setIsOpen(!isOpen);
        }
    }, [isOpen, setIsOpen]);
    return { isOpen, toggleOpen };
};
exports.useAccordion = useAccordion;
//# sourceMappingURL=Accordion.js.map